import React, { Component } from 'react';

import { Container, Row, Col } from 'reactstrap';
import TextBox from '@components/TextBox/TextBox';
import MobileListBox from '@components/MobileListBox/MobileListBox';
import PlaneDetails from './PlaneDetails/PlaneDetails';
import ImportImages from '@src/importImages';

const P100 = ImportImages('/compare/p100.png');
const P300 = ImportImages('/compare/p300.png');
//const L650 = ImportImages('/compare/l650.png');
const Clouds = ImportImages('/home/clouds.jpg');

class List extends Component {
  render() {
    let stylesContainer = {};
    if (window.innerWidth < 992) {
      stylesContainer.minHeight = '300px'; //this.props.pageHeight + 'px';
      stylesContainer.paddingTop = '7rem';
    } else {
      stylesContainer.height = this.props.pageHeight + 'px';
    }

    let styles = {};
    let classNames = '';
    if (window.innerWidth < 992) {
      styles.minHeight = this.props.pageHeight + 'px';
      styles.backgroundImage = `url(${Clouds})`;
      styles.backgroundSize = '100% 100%';
      styles.backgroundPosition = 'center center';
      classNames = 'pt-6 pb-4';
    } else {
      styles.height = this.props.pageHeight + 'px';
      classNames = 'abs-container d-flex align-items-center';
    }

    const box = {
      header: 'Meet the Jets',
      content:
        'From our four-passenger Embraer Phenom 100s, to our seven-passenger Phenom 300s, the JetSuite fleet offers' +
          ' a range of luxury options to fit every travel need, all outfitted with' +
        ' state-of-the-art interiors and Wifi connectivity.'
    };

    return (
      <div
        id={this.props.id}
        className={'panel d-flex align-items-center'}
        style={styles}
      >
        <img
          src={Clouds}
          alt={'Slider1'}
          className={'img-fluid d-none d-lg-block'}
        />
        <Container fluid={true} className={classNames} style={stylesContainer}>
          <Row className={'align-items-center'}>
            <Col md={{ offset: 1, size: 5 }} className={'d-none d-md-block'}>
              <Row className={' justify-content-center'}>
                <Col md={6} className={'mb-4'}>
                  <div
                    className={
                      'background-white red-hover pointer px-4 compare-content ' +
                      (this.props.heightSm ? 'py-3' : 'py-5')
                    }
                    onClick={() => this.props.click('P100')}
                  >
                    <img
                      src={P100}
                      alt={'Phenom 100'}
                      className={'img-fluid d-block mx-auto'}
                      style={{ height: '50px' }}
                    />
                    <div
                      className={
                        'text-center text-uppercase lakes-demibold pt-3'
                      }
                      style={{ letterSpacing: '2px' }}
                    >
                      Phenom 100
                    </div>
                  </div>
                </Col>
                <Col md={6} className={'mb-4'}>
                  <div
                    className={
                      'background-white red-hover pointer px-4 compare-content ' +
                      (this.props.heightSm ? 'py-3' : 'py-5')
                    }
                    onClick={() => this.props.click('P300')}
                  >
                    <img
                      src={P300}
                      alt={'Phenom 300'}
                      className={'img-fluid d-block  mx-auto'}
                      style={{ height: '50px' }}
                    />
                    <div
                      className={
                        'text-center text-uppercase lakes-demibold pt-3'
                      }
                    >
                      Phenom 300
                    </div>
                  </div>
                </Col>
                {/*<Col md={6} className={'mb-4'}>
                  <div
                    className={
                      'background-white red-hover pointer px-4 compare-content ' +
                      (this.props.heightSm ? 'py-3' : 'py-5')
                    }
                    onClick={() => this.props.click('L850')}
                  >
                    <img
                      src={L650}
                      alt={'Legacy 650'}
                      className={'img-fluid d-block mx-auto'}
                      style={{ height: '50px' }}
                    />
                    <div
                      className={
                        'text-center text-uppercase lakes-demibold pt-3'
                      }
                    >
                      Legacy 650
                    </div>
                  </div>
                </Col>*/}
              </Row>
            </Col>
            <Col xs={12} md={{ offset: 1, size: 4 }}>
              <TextBox {...box} isHeader={true}/>
            </Col>
          </Row>
          <Row className={'d-md-none mt-4'}>
            <Col className={'px-0'}>
              <MobileListBox
                parentClassName={'py-3 px-5'}
                className={'background-grey px-4'}
                activeBoxId={this.props.activeMobileBox}
                box={{
                  id: 'p100',
                  title: 'Phenom 100',
                  content: <PlaneDetails {...this.props.planesData.p100} />
                }}
                click={() => this.props.click('p100')}
              />
              <MobileListBox
                parentClassName={'py-3 px-5'}
                className={'background-grey pl-3'}
                activeBoxId={this.props.activeMobileBox}
                box={{
                  id: 'p300',
                  title: 'Phenom 300',
                  content: <PlaneDetails {...this.props.planesData.p300} />
                }}
                click={() => this.props.click('p300')}
              />
              {/*<MobileListBox
                parentClassName={'py-3 px-5'}
                className={'background-grey px-4'}
                activeBoxId={this.props.activeMobileBox}
                box={{
                  id: 'l650',
                  title: 'Legacy 650',
                  content: <PlaneDetails {...this.props.planesData.l650} />
                }}
                click={() => this.props.click('l650')}
              />*/}
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default List;



// WEBPACK FOOTER //
// ./src/components/OurAircraft/List/List.js